<template>
  <div class="container container--ultrawide">
    <nav
      class="W3S-navbar"
      :class="{ 'W3S-navbar--sticky': scroll > 100 }"
      ref="navbar"
    >
      <a href="/">
        <div class="W3S-logo"></div>
      </a>

      <div class="W3S-navbar__links">
        <div class="W3S-navbar__links--left">
          <router-link
            to="/"
            class="W3S-navbar__link"
            :class="{
              'W3S-navbar__link--active': $route.meta.activeTab === 'home',
            }"
          >
            <span>Home</span>
          </router-link>

          <router-link
            :to="{ name: 'games' }"
            class="W3S-navbar__link"
            :class="{
              'W3S-navbar__link--active': $route.meta.activeTab === 'games',
            }"
          >
            <span>Games</span>
          </router-link>

          <!-- <div
            class="W3S-navbar__link"
            :class="{
              'W3S-navbar__link--active'  : $route.meta.activeTab === 'games',
              'W3S-navbar__link--toggled' : toggled === 'games'
            }"
            @click="toggle ('games')"
          >
            <span>
              Games
              <i class="W3S-navbar__icon fas fa-angle-down" v-if="toggled !== 'games'"></i>
              <i class="W3S-navbar__icon fas fa-angle-up" v-if="toggled === 'games'"></i>
            </span>
          </div> -->

          <!--           <router-link to="/players"
              class="W3S-navbar__link"
              :class="{ 'W3S-navbar__link--active' : $route.meta.activeTab === 'players' }">
            <span>Players</span>
          </router-link> -->

          <div
            class="W3S-navbar__link"
            :class="{
              'W3S-navbar__link--active': $route.meta.activeTab === 'maps',
              'W3S-navbar__link--toggled': toggled === 'maps',
            }"
            @click="toggle('maps')"
          >
            <span>
              Maps
              <i
                class="W3S-navbar__icon fas fa-angle-down"
                v-if="toggled !== 'maps'"
              ></i>
              <i
                class="W3S-navbar__icon fas fa-angle-up"
                v-if="toggled === 'maps'"
              ></i>
            </span>
          </div>

          <router-link
            to="/upload"
            class="W3S-navbar__link"
            :class="{
              'W3S-navbar__link--active': $route.meta.activeTab === 'upload',
            }"
          >
            <span>Upload</span>
          </router-link>

          <!-- <div class="W3S-navbar__link">
            <span>Wiki</span>
          </div> -->
        </div>

        <a
          href="https://patreon.com/wc3stats"
          class="W3S-navbar__link hoverable"
          target="_blank"
        >
          <Sparkly :value="'Patreon'"></Sparkly>
        </a>

        <router-link
          :to="{ name: 'gamelist' }"
          class="W3S-navbar__link"
          :class="{
            'W3S-navbar__link--active': $route.meta.activeTab === 'gamelist',
          }"
        >
          <span>Lobbies <sup class="W3S-navbar__link--live">Live</sup></span>
        </router-link>

        <div class="W3S-navbar__links--right">
          <div
            class="W3S-navbar__link d-none d-md-block"
            :class="{ 'W3S-navbar__link--toggled': toggled === 'info' }"
            @click="toggle('info')"
          >
            <span>
              Info
              <i
                class="W3S-navbar__icon fas fa-angle-down"
                v-if="toggled !== 'info'"
              ></i>
              <i
                class="W3S-navbar__icon fas fa-angle-up"
                v-if="toggled === 'info'"
              ></i>
            </span>
          </div>

          <!-- <router-link
            :to="{ name: 'discord' }"
            target="_blank"
            class="W3S-navbar__link"
          >
            <span>Discord</span>
          </router-link> -->
          <!-- <div class="W3S-navbar__link d-none d-md-block">
            <a href="https://www.patreon.com/wc3stats" target="_blank" class="yellow">
              <i class="fab fa-patreon mr-2"></i> Support
            </a>
          </div> -->

          <!-- <div class="W3S-navbar__link">
            <span>Register</span>
          </div> -->

          <!-- <div class="W3S-navbar__link W3S-navbar__toggle d-md-none" ref="miniBars" @click="toggleMini">
            <div></div>
            <div></div>
            <div></div>
          </div> -->
        </div>
      </div>

      <!-- <div class="W3S-navbar__dropdown" v-if="toggled === 'games'">
        <ul class="W3S-navbar__dropdown__columns">
          <li class="W3S-navbar__dropdown__column">
            <div class="W3S-navbar__dropdown__title">General</div>
            <router-link :to="{ name: 'gamelist' }">
              <Icon
                src="/assets/icons/clan.png"
                :size="32"
                :circle="true"
                class="link yellow"
              >
                Active Lobbies
              </Icon>
            </router-link>

            <router-link :to="{ name: 'games' }">
              <Icon
                src="/assets/icons/map.png"
                :size="32"
                :circle="true"
                class="link yellow"
              >
                Replay Archives
              </Icon>
            </router-link>
          </li>
        </ul>
      </div> -->

      <div class="W3S-navbar__dropdown" v-show="toggled === 'maps'" ref="maps">
        <ul class="W3S-navbar__dropdown__columns">
          <li class="W3S-navbar__dropdown__column">
            <div class="W3S-navbar__dropdown__title">Featured</div>

            <!--<router-link :to="{ name: 'Broken Alliances', params: { tab: 'leaderboard' } }">
              Broken Alliances

              <span class="W3S-navbar__upload-stats">{{ statsFor ('Broken Alliances') }}</span>
              <span class="W3S-navbar__upload-stats">Developing</span>

              <i
                class="fas fa-trophy ml10 yellow"
                v-tooltip="'<strong>Active Tournament</strong> <br> Prize Pool: 50 USD'"></i>
            </router-link>-->

            <!--<router-link :to="{ name: 'Risk Europe', params: { tab: 'leaderboard' } }">
              Risk Europe <span class="W3S-navbar__upload-stats">{{ statsFor ('Risk Europe') }}</span>
            </router-link>-->

            <router-link
              :to="{
                name: 'Footmen Vs Grunts',
                params: { tab: 'leaderboard' },
              }"
            >
              Footmen Vs Grunts
              <span class="W3S-navbar__upload-stats">{{
                statsFor("Footmen Vs Grunts")
              }}</span>
            </router-link>

            <router-link
              :to="{
                name: 'ACR',
                params: { tab: 'leaderboard' },
              }"
              data-map="ACR"
            >
              Anime Carnage Reforged
              <span class="W3S-navbar__upload-stats">{{
                statsFor("ACR")
              }}</span>
            </router-link>

            <!-- <router-link :to="{ name: 'Warcraft Melee' }">
              Warcraft Melee
            </router-link> -->

            <router-link :to="{ name: 'Reforged Footmen Frenzy', params: { tab: 'leaderboard' } }" data-map="Reforged Footmen Frenzy">
              Footmen Frenzy <span class="W3S-navbar__upload-stats">{{ statsFor ('Reforged Footmen Frenzy') }}</span>
            </router-link>

            <router-link
              :to="{
                name: 'Direct Strike Reforged',
                params: { tab: 'leaderboard' },
              }"
              data-map="Direct Strike Reforged"
            >
              Direct Strike
              <span class="W3S-navbar__upload-stats">{{
                statsFor("Direct Strike Reforged")
              }}</span>
            </router-link>

            <router-link :to="{ name: 'WW3 Diplomacy', params: { tab: 'leaderboard' } }" data-map="WW3 Diplomacy">
              WW3 Diplomacy <span class="W3S-navbar__upload-stats">{{ statsFor ('WW3 Diplomacy') }}</span>
            </router-link>

            <!-- <router-link :to="{ name: 'War Of The Kings' }">
              War of the Kings
            </router-link> -->

            <!-- <router-link :to="{ name: 'Path Wars' }">
              Path Wars
            </router-link> -->

            <!-- <router-link :to="{ name: 'Footmen Apocalypse' }">
              Footmen Apocalypse <span class="W3S-navbar__upload-stats">{{ statsFor ('Footmen Apocalypse') }}</span>
            </router-link> -->
          </li>

          <li class="W3S-navbar__dropdown__column">
            <div class="W3S-navbar__dropdown__title">Survival & Vampirism</div>

            <!--<router-link :to="{ name: 'Weed Vs Greed', params: { tab: 'leaderboard' } }" data-map="Weed Vs Greed">
              Weed vs. Greed <span class="W3S-navbar__upload-stats">{{ statsFor ('Weed Vs Greed') }}</span>
            </router-link>

            <router-link :to="{ name: 'M.Z.I', params: { tab: 'leaderboard' }  }">
              M.Z.I <span class="W3S-navbar__upload-stats">{{ statsFor ('M.Z.I') }}</span>
            </router-link>-->

            <router-link
              :to="{
                name: 'Dark Ages Zombie Incursion',
                params: { tab: 'leaderboard' },
              }"
              data-map="Dark Ages Zombie Incursion"
            >
              D.A.Z.I
              <span class="W3S-navbar__upload-stats">{{
                statsFor("Dark Ages Zombie Incursion")
              }}</span>
            </router-link>

            <router-link
              :to="{ name: 'Vampirism Fire', params: { tab: 'leaderboard' } }"
            >
              Vampirism Fire
              <span class="W3S-navbar__upload-stats">{{
                statsFor("Vampirism Fire")
              }}</span>
            </router-link>

            <!--<router-link :to="{ name: 'Sheep Tag', params: { tab: 'leaderboard' } }">
              Sheep Tag <span class="W3S-navbar__upload-stats">{{ statsFor ('Sheep Tag') }}</span>
            </router-link>-->

            <router-link
              :to="{ name: 'Tree Tag', params: { tab: 'leaderboard' } }"
            >
              Tree Tag
              <span class="W3S-navbar__upload-stats">{{
                statsFor("Tree Tag")
              }}</span>
            </router-link>

            <!--<router-link :to="{ name: 'Warlock Brawl', params: { tab: 'leaderboard' } }">Warlock Brawl <span class="W3S-navbar__upload-stats">{{ statsFor ('Warlock Brawl') }}</span></router-link>
            <router-link :to="{ name: 'MZA', params: { tab: 'leaderboard' } }" data-map="MZA">Medieval Zombie Apoc. <span class="W3S-navbar__upload-stats">{{ statsFor ('MZA') }}</span></router-link>-->
          </li>

          <!-- <li class="W3S-navbar__dropdown__column">
            <div class="W3S-navbar__dropdown__title">Hero</div> -->

          <!-- <router-link :to="{ name: 'Warcraft Royale' }">Warcraft Royale</router-link> -->
          <!-- <router-link :to="{ name: 'DotA' }">DotA</router-link> -->
          <!-- <router-link :to="{ name: 'Battleships Crossfire', params: { tab: 'leaderboard' } }">Battleships Crossfire <span class="W3S-navbar__upload-stats">{{ statsFor ('Battleships Crossfire') }}</span></router-link> -->
          <!-- <router-link :to="{ name: 'The Forest Of Fables' }">
              The Forest of Fables
            </router-link> -->

          <!-- <a href="#" class="grey">Orc Gladiators Revenge</a> -->
          <!-- </li> -->

          <li class="W3S-navbar__dropdown__column">
            <div class="W3S-navbar__dropdown__title">Tower Defense</div>

            <!--<router-link
              :to="{ name: 'Wintermaul Wars', params: { tab: 'leaderboard' } }"
              >Wintermaul Wars
              <span class="W3S-navbar__upload-stats">{{
                statsFor("Wintermaul Wars")
              }}</span></router-link
            >-->
            <router-link
              :to="{ name: 'Castle Fight', params: { tab: 'leaderboard' } }"
              >Castle Fight
              <span class="W3S-navbar__upload-stats">{{
                statsFor("Castle Fight")
              }}</span></router-link
            >
            <!--<router-link :to="{ name: 'Mazing Contest', params: { tab: 'leaderboard' } }">Mazing Contest <span class="W3S-navbar__upload-stats">{{ statsFor ('Mazing Contest') }}</span></router-link>-->
            <router-link
              :to="{ name: 'Legion TD', params: { tab: 'leaderboard' } }"
              >Legion TD
              <span class="W3S-navbar__upload-stats">{{
                statsFor("Legion TD")
              }}</span></router-link
            >
            <!--<router-link :to="{ name: 'Green Solo TD', params: { tab: 'leaderboard' } }">Green Solo TD <span class="W3S-navbar__upload-stats">{{ statsFor ('Green Solo TD') }}</span></router-link>-->
            <!--<router-link :to="{ name: 'Pyro TD', params: { tab: 'leaderboard' } }">Pyro TD <span class="W3S-navbar__upload-stats">{{ statsFor ('Pyro TD') }}</span></router-link>-->
            <!-- <router-link :to="{ name: 'Circle TD Trollforged' }">
              Trollforged TD
            </router-link> -->

            <!-- <router-link :to="{ name: 'Line Tower Wars' }">
              Line Tower Wars
            </router-link> -->

            <!-- <a href="#" class="grey">Legion TD</a> -->
            <!-- <a href="#" class="grey">Power Towers</a> -->
          </li>

          <li class="W3S-navbar__dropdown__column">
            <div class="W3S-navbar__dropdown__title">Other</div>

            <!--<router-link
              :to="{
                name: 'Kings And Knights Alpha',
                params: { tab: 'leaderboard' },
              }"
              data-map="Kings And Knights Alpha"
            >
              Kings and Knights
              <span class="W3S-navbar__upload-stats">{{
                statsFor("Kings And Knights Alpha")
              }}</span>
            </router-link>-->

            <router-link
              :to="{
                name: 'Anime Choice Arena',
                params: { tab: 'leaderboard' },
              }"
              >Anime Choice Arena
              <span class="W3S-navbar__upload-stats">{{
                statsFor("Anime Choice Arena")
              }}</span></router-link
            >

            <router-link
              :to="{
                name: 'Battleships Crossfire',
                params: { tab: 'leaderboard' },
              }"
              >Battleships Crossfire
              <span class="W3S-navbar__upload-stats">{{
                statsFor("Battleships Crossfire")
              }}</span></router-link
            >

            <router-link
              :to="{ name: 'Helms Deep', params: { tab: 'leaderboard' } }"
            >
              Helms Deep
              <span class="W3S-navbar__upload-stats">{{
                statsFor("Helms Deep")
              }}</span>
            </router-link>

            <router-link :to="{ name: 'Fight of Anime RvE', params: { tab: 'leaderboard' } }">
              Fight of Anime RvE <span class="W3S-navbar__upload-stats">{{ statsFor ('Fight of Anime RvE') }}</span>
            </router-link>

            <!--<router-link
              :to="{
                name: 'Horde vs Alliance',
                params: { tab: 'leaderboard' },
              }"
            >
              Horde vs Alliance
              <span class="W3S-navbar__upload-stats">{{
                statsFor("Horde vs Alliance")
              }}</span>
            </router-link>-->

            <!--<router-link :to="{ name: 'Nwu', params: { tab: 'leaderboard' } }" data-map="Nwu">
              Naruto Wars <span class="W3S-navbar__upload-stats">{{ statsFor ('Nwu') }}</span>
            </router-link>-->

            <router-link
              :to="{ name: 'HLW', params: { tab: 'leaderboard' } }"
              data-map="HLW"
            >
              Hero Line Wars
              <span class="W3S-navbar__upload-stats">{{
                statsFor("HLW")
              }}</span>
            </router-link>

            <!--<router-link :to="{ name: 'Anime Battle', params: { tab: 'leaderboard' } }">
              Anime Battle <span class="W3S-navbar__upload-stats">{{ statsFor ('Anime Battle') }}</span>
            </router-link>-->
          </li>
        </ul>
      </div>

      <div class="W3S-navbar__dropdown" v-if="toggled === 'info'">
        <ul class="W3S-navbar__dropdown__columns">
          <li class="W3S-navbar__dropdown__column">
            <div class="W3S-navbar__dropdown__title">Tools</div>

            <router-link :to="{ name: 'hosting' }"
              >Hosting Statistics</router-link
            >

            <!-- <a
              href="https://discord.gg/YEHnctN"
              target="_blank"
            >
              <Icon
                src="/assets/icons/affiliate/w3u.png"
                :size="32"
                :circle="true"
                class="link yellow"
              >
                Warcraft III United
              </Icon>
            </a>

            <a
              href="https://discord.gg/hDKgWKy"
              target="_blank"
            >
              <Icon
                src="/assets/icons/affiliate/fbg.png"
                :size="32"
                :circle="true"
                class="link yellow"
              >
                First Blood Gaming
              </Icon>
            </a> -->
          </li>

          <li class="W3S-navbar__dropdown__column">
            <div class="W3S-navbar__dropdown__title">Players</div>

            <a href="https://github.com/wc3stats/auto-uploader#installation"
              >Automatic Replay Uploader</a
            >
            <a href="https://github.com/wc3stats/scantron-9000"
              >Scantron 9000</a
            >
          </li>

          <li class="W3S-navbar__dropdown__column">
            <div class="W3S-navbar__dropdown__title">
              Mappers
              <!-- <i
                class="fas fa-exclamation ml10 red"
                v-tooltip="'These pages will be ported to formatted articles in the future.'"></i> -->
            </div>

            <router-link
              :to="{ name: 'Documentation', params: { page: 'about' } }"
              >About</router-link
            >
            <router-link
              :to="{ name: 'Documentation', params: { page: 'api' } }"
              >API</router-link
            >
            <router-link
              :to="{ name: 'Documentation', params: { page: 'w3mmd' } }"
              >W3MMD Guide</router-link
            >

            <!-- <a href="/assets/docs/about.txt">About</a>
            <a href="/assets/docs/api.txt">API</a>
            <a href="/assets/docs/w3mmd.txt">W3MMD Guide</a> -->
          </li>

          <li class="W3S-navbar__dropdown__column">
            <div class="W3S-navbar__dropdown__title">Other</div>

            <a href="https://discord.gg/N3VGkUM" class="hoverable">
              <i class="fab fa-discord mr-2"></i> Discord
            </a>

            <a href="https://patreon.com/wc3stats" class="hoverable orange">
              <i class="fab fa-patreon mr-2"></i> Patreon
            </a>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
import Icon from "@/legacy/components/widgets/Icon";
import Sparkly from "@/legacy/components/widgets/Sparkly";
import Api from "@/legacy/lib//Api";
import { eventPath } from "@/legacy/lib//util";

export default {
  components: {
    Icon,
    Sparkly,
  },

  data: function() {
    return {
      toggled: null,
      reset: null,
      scroll: window.scrollY,
      stats: [],
    };
  },

  mounted() {
    let maps = Array.from(this.$refs.maps.querySelectorAll("a")).map(
      (em) => em.getAttribute("data-map") || em.textContent.trim()
    );

    let body = new FormData();

    maps.forEach((map) => body.append("maps[]", map));

    Api.get("/maps/stats", body)
      .then(async (res) => {
        let json = await res.json();
        this.stats = json.body;
      })

      .catch((err) => {
        console.log(err);
      });
  },

  created() {
    window.addEventListener("scroll", this.onScroll);
  },

  destroyed() {
    window.removeEventListener("scroll", this.onScroll);
  },

  methods: {
    toggle: function(target) {
      if (this.toggled === target) {
        this.toggled = null;
      } else {
        this.toggled = target;

        window.addEventListener("click", this.bindClose);
      }
    },

    toggleMini(e) {
      let miniBars = this.$refs.miniBars;

      if (miniBars.classList.contains("toggled")) {
        miniBars.classList.remove("toggled");
      } else {
        miniBars.classList.add("toggled");
      }
    },

    onScroll() {
      this.scroll = window.scrollY;
    },

    bindClose(e) {
      for (let em of eventPath(e)) {
        if (em === this.$refs.navbar) {
          return;
        }
      }

      this.toggled = null;
      window.removeEventListener("click", this.bindClose);
    },

    statsFor(map) {
      let stats = this.stats.find((x) => x.map === map);

      if (!stats) {
        return "";
      }

      return `${stats.uploads1} / ${stats.uploads7}`;
    },
  },

  watch: {
    $route: function(to, from) {
      this.toggled = null;
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style lang="scss">
$navbar-border-colour: shade($w3s-grey, 60);
$navbar-logo-width: 240px;
$navbar-logo-height: 200px;
$navbar-height: 90px;
$navbar-sticky-height: 60px;
$navbar-sticky-transition: 0.25s;

.W3S-navbar {
  background: $w3s-grey-dark asset("navbar-bg-grey.jpg") repeat-x 80px 0;
  background-size: contain;
  border: 1px solid $navbar-border-colour;
  border-radius: $w3s-border-radius;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.6);
  display: flex;
  flex-direction: row;
  height: $navbar-height;
  position: absolute;
  top: 80px;
  left: 0;
  right: 0;
  // transition: width $w3s-transition-fast;
  width: 100%;
  max-width: 88%;
  margin: auto;
  z-index: 100;

  .W3S-logo {
    height: 200px;
    position: absolute;
    top: -57px;
    left: -60px;
    width: $navbar-logo-width;
    z-index: 20;
  }

  &__links {
    display: flex;
    flex-direction: row;
    width: 100%;
    margin-left: 210px;

    &--left,
    &--right {
      display: flex;
      flex-direction: row;
    }

    &--left {
      flex-grow: 1;
    }

    &--right {
    }
  }

  &__link {
    border-left: 1px solid $w3s-black;
    color: $w3s-yellow;
    height: $navbar-height;
    line-height: $navbar-height / 2 + 2;
    font-size: 1.25em;
    max-height: 100%;
    padding: 1em 1.25em;
    position: relative;
    text-transform: uppercase;
    transition: background-color $navbar-sticky-transition;
    user-select: none;

    > span,
    .fas {
      @include text-gradient(top, #ddd 0, #eee 60%, #fff 100%)
        // @include text-gradient(top,#3e9cdc 0,#3E4FDC 38%,#3E6EDC 60%,#3EB6DC 86%,#3EAFDC 100%);
        // @include text-gradient(top,#efd100 0,#e2a233 38%,#f0c328 60%,#fff1a3 86%,#ffe13e 100%);;
    }

    &--toggled {
      background-color: rgba($w3s-grey-light, 0.2);
    }

    &--active {
      background-color: rgba($w3s-grey-light, 0.1);
    }

    &--live {
      -webkit-text-fill-color: $green;
    }

    &:before,
    &:after {
      background: $w3s-grey;
      bottom: 0;
      content: "";
      opacity: 0.5;
      position: absolute;
      top: 0;
      width: 1px;
    }

    &:before {
      left: 0;
    }

    &:after {
      opacity: 0;
      right: -2px;
    }

    &:last-child {
      border-right: w3s-border($w3s-black);

      &:after {
        opacity: 0.5;
      }
    }

    &:hover {
      background-color: rgba($w3s-grey-light, 0.25);
      // border: 1px solid rgba($w3s-red, 0.25);
      color: $w3s-white;
      cursor: pointer;

      span,
      .fas {
        @include text-gradient-reset();
        color: $w3s-white;
      }
    }
  }

  &__upload-stats {
    font-size: 0.8rem;
    color: $orange;
    margin-left: auto;
  }

  &__dropdown {
    background: linear-gradient(
      to bottom,
      $w3s-grey-dark,
      shade($w3s-grey-dark, 98)
    );
    position: absolute;
    top: $navbar-height - 1px;
    right: -1px;
    width: 100%;
    z-index: 10;

    &__columns {
      display: flex;
      list-style-type: none;
      margin-top: 60px;
      padding: 0 5em 2em;
    }

    &__column {
      flex-grow: 1;
      flex-basis: 25%;
      margin: 0 2em;
    }

    &__title {
      border-bottom: 1px solid $w3s-grey;
      // color: shade($w3s-white, 80);
      color: $w3s-purple-light;
      font-weight: bold;
      margin-bottom: 1rem;
      padding: 0.25rem 0;
    }

    &__mural {
      list-style-type: none;
      display: flex;
      margin-top: 60px;
      padding: 0 1em 1em;

      &__item {
        flex-grow: 1;
        text-align: center;
        font-size: 2.5rem;
        font-family: "Folkard";
        padding: 2rem;
        // margin: 1rem;

        &:first-child {
          border-right: fetch(border faint);
        }
      }
    }

    a {
      display: flex;
      align-items: center;
    }
  }

  &--sticky {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: $navbar-sticky-height;
    max-width: 100%;

    .W3S-logo {
      background-image: asset("/logo-collapsed.png");
      height: $navbar-sticky-height;
      left: 40px;
      top: 0;
      width: 200px;
    }

    .W3S-navbar {
      &__links {
        margin-left: 260px;
      }

      &__link,
      &__icon {
        line-height: $navbar-sticky-height / 2 - 14 !important;
      }

      &__dropdown {
        top: $navbar-sticky-height - 1px;
      }

      &__toggle {
        > div {
          &:nth-child(1) {
            margin-top: -2px;
          }
        }
      }
    }
  }

  &__toggle {
    display: inline-block;
    cursor: pointer;

    > div {
      width: 35px;
      height: 4px;
      background-color: rgba(var(--white), 0.5);
      margin: 6px 0;
      transition: 0.4s;

      &:nth-child(1) {
        margin-top: 10px;
      }
    }

    &:hover {
      background-color: transparent;

      > div {
        background-color: rgba(var(--white), 0.7);
      }
    }

    &.toggled {
      > div {
        background-color: rgba(var(--white), 1);

        &:nth-child(1) {
          transform: rotate(-45deg) translate(-7px, 6px);
        }

        &:nth-child(2) {
          opacity: 0;
        }

        &:nth-child(3) {
          transform: rotate(45deg) translate(-8px, -7px);
        }
      }
    }
  }
}
</style>
